<div class="row">
  <div class="col-12 mt-2">
    <h5 class="text-primary" id="paymentsTitle">Informations de paiement</h5>
  </div>
</div>
<div class="row mt-2">
  <div class="mb-3 col-3">
    <label>Date du prochain paiement</label>
    <input type="text" class="form-control" [value]="nextPayment?.paymentMonth | date: 'MMM yyyy'" [readonly]="true" />
  </div>
  <div class="mb-3 col-3">
    <label>Montant du prochain paiement</label>
    <input type="text" class="form-control" [value]="nextPayment?.amount" [readonly]="true" />
  </div>
  <div class="col-3"></div>
  <div class="mb-3 col-3">
    <label>Droits de tirage restant</label>
    <input type="text" class="form-control" [value]="rsjDto?.remainingPayment" [readonly]="true" />
  </div>
</div>
<div class="row mt-1">
  @if (!payments || payments?.items?.length === 0) {
    <p class="ms-3 pt-2 text-secondary">Aucune information de paiements n'est disponible.</p>
  }
  @if (payments?.items?.length > 0) {
    <div class="col px-0 pt-2">
      <div class="table-responsive">
        <table class="table table-striped table-hover" aria-describedby="paymentsTitle">
          <thead class="text-secondary bg-light">
            <tr>
              <th></th>
              <th scope="col" class="text-center">Date de statut</th>
              <th scope="col" class="text-center">Statut</th>
              <th scope="col" class="text-center">Mois du virement</th>
              <th scope="col" class="text-center">Montant</th>
              <th scope="col" class="text-center">BIC / SWIFT</th>
              <th scope="col" class="text-center">IBAN</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (payment of payments?.items; track payment) {
              <tr>
                <td></td>
                <td class="text-center">
                  {{ payment.stateDate | date: 'd MMM yyyy' }}
                </td>
                <td class="text-center">
                  {{ payment.state }}
                </td>
                <td class="text-center">
                  {{ payment.paymentMonth | date: 'MMM yyyy' }}
                </td>
                <td class="text-center">
                  {{ payment.amount }}
                </td>
                <td class="text-center">
                  {{ payment.bic }}
                </td>
                <td class="text-center">
                  {{ payment.iban }}
                </td>
                <td class="text-center">
                  @if (['Réalisé', 'Erreur de paiement traitée'].includes(payment.state)) {
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary btn-sm"
                      ngbTooltip="Passer le paiement à l'état 'Erreur de paiement'"
                      (click)="updatePaymentInfoStatus(payment.id)"
                      placement="left"
                      *appOnlyGroups="['ADMIN', 'DIRECTION+']"
                      >
                      <fa-icon class="d-block" icon="bell"></fa-icon>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
@if (payments?.items?.length > 0) {
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="payments?.totalItems"
      [page]="payments?.options?.page"
      [pageSize]="payments?.options?.limit"
      [maxSize]="5"
      [rotate]="true"
      [boundaryLinks]="true"
      (pageChange)="changePage($event)"
      >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="payments?.options?.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
}
